<template>
    <div class="card page-height">
        <div class="card-header">
            <h4 class="card-title mb-0">Select Quotes</h4>
        </div>
        <!--<div class="page-title">
            <div class="title-right btnrow float-right">
            <router-link :to="{ name: 'selectProducts'}" class="btn skip-btn">SKIP</router-link>
                <router-link :to="{ name: 'selectProducts'}" class="btn custom-btn ml-3"
                             :class="[newOrder.quotations.length == 0 ? 'disabled':'']">Next
                </router-link>
            </div>
        </div>-->
         <div class="card-body form-steps">
            <div class="select-step">
                <!-- progressbar -->
                <ul id="progressbar" class="mb-4">
                    <li><span>Select Customer</span></li>
                    <li class="active"><span>Select Quotes</span></li>
                    <li><span>Select Products</span></li>
                    <li><span>Provide Other Info</span></li>
                </ul>
                <!-- fieldsets -->
                <fieldset class="search">
                    <div class="row">
                        <div class="col-sm-7 col-md-7">
                            <form class="form-inline" action="" @submit.prevent="search()">
                                <div class="autocomplete-form">
                                    <autocomplete
                                        :source="quoteSearchEndpoint"
                                        :requestHeaders="authHeaders"
                                        :resultsFormatter="resultsFormatter"
                                        ref="autocomplete"
                                        placeholder="Quick Search"
                                        input-class="form-control"
                                        @selected="selectFilterQuote($event)"
                                        @clear="selectFilterQuote(null)"
                                    />

                                </div>
                            </form>
                        </div>
                        <div class="col-sm-5 col-md-5">
                            <div class="title-right new-custom-sec2 float-right">

                            </div>
                        </div>
                    </div>
                </fieldset>

                <div class="quote-step02">
                    <Quotations :customer_id="newOrder.customer_id" :selectedQuotations="newOrder.quotations" :search_filter="search_filter"
                                @selectQuotation="selectQuotation($event)"  :bus="bus" ref="quotationList"></Quotations>
                </div>


            </div>
        </div>
        <div class="card-footer">
            <div class="btnrow text-right">
                <button type="button" @click="goBack" class="btn btn-light btn-label left-btn previestab w-lg" data-previous="steparrow-gen-info-tab"><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</button>
                    <router-link :to="{ name: 'selectProducts'}" class="btn skip-btn">SKIP</router-link>
                    <router-link :to="{ name: 'selectProducts'}" class="btn  btn-success right btn-label ml-3"
                                :class="[newOrder.quotations.length == 0 ? 'disabled':'']"><i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i> Next
                    </router-link>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";
import Quotations from "../../components/Quotations";
import Vue from "vue";
import Autocomplete from 'vuejs-auto-complete'

export default {
    name: "SelectQuotes",
    components: {
        Quotations,
        Autocomplete
    },
    created() {
        if(localStorage.getItem('token')){
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        if(this.salesOrderState) {
            this.newOrder = this.salesOrderState.newOrder;
        }
    },
    beforeRouteLeave (to, from , next) {
        if(to.name == 'selectCustomer' || to.name == 'selectProducts') {
            next();
        } else {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                next();
            } else {
                next(false);
            }
        }
    },
    data(){
        return {
            bus: new Vue(),
            newOrder: {
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products:[],
                selectedProducts: [],
            },
            search_filter: null
        }
    },
    mounted() {

    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setNewOrder',
            'setOrdersLoading',
        ]),
        goBack() {
            this.$router.push({name: 'selectCustomer'});
        },
        selectQuotation(event) {
            if(event.c) {
                if(this.newOrder.quotations.includes(event.c)) {
                    if(event.checked == false) {
                        this.newOrder.quotations.splice(this.newOrder.quotations.indexOf(event.c), 1)
                    }
                } else {
                    this.newOrder.quotations.push(event.c);
                }
            }

            this.setNewOrder(this.newOrder);
        },
        search() {
            this.bus.$emit('getQuotations')
        },
        quoteSearchEndpoint(input) {
            return window.route('quotations.index', {page: 1, per_page: 20, search_filter: input, customer_id: this.newOrder.customer_id, so_sent_to_customer: true});
        },
        resultsFormatter(result) {
            // console.log(result)
            if (!result.errorMessage && result.data.quotations.data.length) {
                let quotations = [];
                result.data.quotations.data.forEach((x) => {
                    quotations.push({
                        id: x.id,
                        name: x.quotation_number
                    });
                });

                return quotations;
            }
            return [];
        },
        selectFilterQuote(event) {
            console.log(event);
            this.search_filter = event != null ? event.selectedObject.name : '';
            setTimeout(() => {
                this.search();
            }, 500);
        },
    },
    watch: {

    },
    computed: {
        ...mapState([
            'userState',
            'salesOrderState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'ordersLoading',
            'getSalesOrderState'
        ]),
        authHeaders() {
            return {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }
        },
    }
}
</script>

<style scoped>

</style>
